// utils/image/compressImage.ts
export interface CompressOpts {
  maxWidth?: number;      // e.g. 512
  maxHeight?: number;     // e.g. 512
  quality?: number;       // 0..1  (for JPEG/WebP)
  outputType?: "image/jpeg" | "image/webp" | "image/png";
}

export async function compressImageToDataURL(file: File, opts: CompressOpts = {}): Promise<string> {
  const {
    maxWidth = 512,
    maxHeight = 512,
    quality = 0.82,
    outputType = "image/jpeg",
  } = opts;

  const bitmap = await createImageBitmap(file);
  const { width, height } = bitmap;

  // maintain aspect ratio
  let targetW = width;
  let targetH = height;
  if (width > maxWidth || height > maxHeight) {
    const ratio = Math.min(maxWidth / width, maxHeight / height);
    targetW = Math.round(width * ratio);
    targetH = Math.round(height * ratio);
  }

  const canvas = document.createElement("canvas");
  canvas.width = targetW;
  canvas.height = targetH;
  const ctx = canvas.getContext("2d")!;
  ctx.drawImage(bitmap, 0, 0, targetW, targetH);

  // blob -> dataURL
  const blob: Blob = await new Promise((resolve) => canvas.toBlob((b) => resolve(b!), outputType, quality));
  const dataUrl = await new Promise<string>((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.readAsDataURL(blob);
  });

  return dataUrl;
}
